import type { Dispatch } from 'redux';

import { actionResetAboutBusiness } from 'src/app/v1/state/modules/formData/aboutBusiness';
import { actionResetApplicationFormUrl } from 'src/app/v1/state/modules/formData/applicationFormUrl';
import { actions as actionBenefits } from 'src/app/v1/state/modules/formData/benefits';
import { actionResetBrand } from 'src/app/v1/state/modules/formData/brand';
import { actionResetCategoryId } from 'src/app/v1/state/modules/formData/categoryId';
import { actionResetDisplayPay } from 'src/app/v1/state/modules/formData/displayPay';
import { actionResetDraftProgress } from 'src/app/v1/state/modules/formData/draftProgress';
import { actionResetExpiryDate } from 'src/app/v1/state/modules/formData/expiryDate';
import { actionResetFlowType } from 'src/app/v1/state/modules/formData/flowType';
import { actionResetHasAIAssistanceBeenUsed } from 'src/app/v1/state/modules/formData/hasAIAssistanceBeenUsed';
import { actionResetIsConfidential } from 'src/app/v1/state/modules/formData/isConfidential';
import { actionResetIsGuided } from 'src/app/v1/state/modules/formData/isGuided';
import { actionResetJobAdReference } from 'src/app/v1/state/modules/formData/jobAdReference';
import { actionResetJobDescription } from 'src/app/v1/state/modules/formData/jobDescription';
import { actionResetJobLocationId } from 'src/app/v1/state/modules/formData/jobLocationId';
import { actionResetJobSummary } from 'src/app/v1/state/modules/formData/jobSummary';
import { actionResetJobTitle } from 'src/app/v1/state/modules/formData/jobTitle';
import { actionResetKeySellingPoint1 } from 'src/app/v1/state/modules/formData/keySellingPoint1';
import { actionResetKeySellingPoint2 } from 'src/app/v1/state/modules/formData/keySellingPoint2';
import { actionResetKeySellingPoint3 } from 'src/app/v1/state/modules/formData/keySellingPoint3';
import { actionResetLinkOutApplyVia } from 'src/app/v1/state/modules/formData/linkOutApplyVia';
import { actionResetListingDate } from 'src/app/v1/state/modules/formData/listingDate';
import { actionResetMaxSalary } from 'src/app/v1/state/modules/formData/maxSalary';
import { actionResetMinSalary } from 'src/app/v1/state/modules/formData/minSalary';
import { actionResetPayType } from 'src/app/v1/state/modules/formData/payType';
import { actionResetPaymentOption } from 'src/app/v1/state/modules/formData/paymentOption';
import { actionResetPhoneNumber } from 'src/app/v1/state/modules/formData/phoneNumber';
import { actionResetProductDisplayName } from 'src/app/v1/state/modules/formData/productDisplayName';
import { actions as actionQualifications } from 'src/app/v1/state/modules/formData/qualifications';
import { actionResetQuestionnaireUrl } from 'src/app/v1/state/modules/formData/questionnaireUrl';
import { actions as actionResponsibilities } from 'src/app/v1/state/modules/formData/responsibilities';
import { actionResetSalaryCurrency } from 'src/app/v1/state/modules/formData/salaryCurrency';
import { actionResetSalaryText } from 'src/app/v1/state/modules/formData/salaryText';
import { actionResetSelectedProductId } from 'src/app/v1/state/modules/formData/selectedProductId';
import { actionResetSourceProductId } from 'src/app/v1/state/modules/formData/sourceProductId';
import { actionResetSubCategoryId } from 'src/app/v1/state/modules/formData/subCategoryId';
import { actionResetSuggestedCategoryId } from 'src/app/v1/state/modules/formData/suggestedCategoryId';
import { actionResetVideoUrl } from 'src/app/v1/state/modules/formData/videoUrl';
import { actionResetWorkType } from 'src/app/v1/state/modules/formData/workType';
export default () => (dispatch: Dispatch) => {
  dispatch(actionBenefits.reset());
  dispatch(actionQualifications.reset());
  dispatch(actionResetAboutBusiness());
  dispatch(actionResetApplicationFormUrl());
  dispatch(actionResetBrand());
  dispatch(actionResetCategoryId());
  dispatch(actionResetDisplayPay());
  dispatch(actionResetDraftProgress());
  dispatch(actionResetExpiryDate());
  dispatch(actionResetFlowType());
  dispatch(actionResetHasAIAssistanceBeenUsed());
  dispatch(actionResetIsConfidential());
  dispatch(actionResetIsGuided());
  dispatch(actionResetJobAdReference());
  dispatch(actionResetJobDescription());
  dispatch(actionResetJobLocationId());
  dispatch(actionResetJobSummary());
  dispatch(actionResetJobTitle());
  dispatch(actionResetKeySellingPoint1());
  dispatch(actionResetKeySellingPoint2());
  dispatch(actionResetKeySellingPoint3());
  dispatch(actionResetLinkOutApplyVia());
  dispatch(actionResetListingDate());
  dispatch(actionResetMaxSalary());
  dispatch(actionResetMinSalary());
  dispatch(actionResetPayType());
  dispatch(actionResetPaymentOption());
  dispatch(actionResetPhoneNumber());
  dispatch(actionResetProductDisplayName());
  dispatch(actionResetQuestionnaireUrl());
  dispatch(actionResetSalaryCurrency());
  dispatch(actionResetSalaryText());
  dispatch(actionResetSelectedProductId());
  dispatch(actionResetSubCategoryId());
  dispatch(actionResetSuggestedCategoryId());
  dispatch(actionResetVideoUrl());
  dispatch(actionResetWorkType());
  dispatch(actionResponsibilities.reset());
  dispatch(actionResetSourceProductId());
};
